import { transformIndexDays } from "@/app/shared/utils/transform";

export function groupScheduleConfig(list, keyGetter) {
  if (list.length) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });

    const collectionObject = Object.fromEntries(map);

    let newCollection = [];

    for (let key in collectionObject) {
      const object = {
        day: Number(key),
        nameDay: transformIndexDays([Number(key)])[0]?.day,
        hours: collectionObject[key].map((schedule) => ({
          start: schedule.start_hour,
          end: schedule.end_hour,
          id: schedule.id,
        })),
        order: Number(key),
      };

      newCollection.push(object);
    }

    return newCollection;
  } else {
    console.log("no hay nada");
    return [];
  }
}
